import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="carousel"
export default class extends Controller {
  static targets = ["scrollContainer", "dot"];

  connect() {
    this.updateDots();
  }

  // Fires natively as the user swipes horizontally
  onScroll() {
    this.updateDots();
  }

  updateDots() {
    if (!this.hasScrollContainerTarget || !this.hasDotTarget) return;

    const scrollLeft = this.scrollContainerTarget.scrollLeft;
    const width = this.scrollContainerTarget.clientWidth;

    // Calculate which slide is currently most visible in the viewport
    const activeIndex = Math.round(scrollLeft / width);

    // Update the native expanding dot styling
    this.dotTargets.forEach((dot, index) => {
      if (index === activeIndex) {
        dot.classList.add("bg-white", "w-4");
        dot.classList.remove("bg-white/50", "w-1.5");
      } else {
        dot.classList.add("bg-white/50", "w-1.5");
        dot.classList.remove("bg-white", "w-4");
      }
    });
  }

  // Allows users to tap a dot to snap to that specific image
  scrollTo(event) {
    const index = event.currentTarget.dataset.index;
    const width = this.scrollContainerTarget.clientWidth;

    this.scrollContainerTarget.scrollTo({
      left: index * width,
      behavior: "smooth",
    });
  }
}
